import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const FlatRateLensComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="定額制レンズ注文完了" content="定額制レンズの注文が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default FlatRateLensComplete;